module.exports = __webpack_public_path__ + "assets/ic_menu.292e7a96.svg";